import { ShipmentInfoModel } from '../../../../../../../../../dataTypes';
import { UseAsyncResult, useAsync } from '../../../../../../../../../hooks/useAsync';
import { useService } from '../../../../../../../../../providers/useService';

export function useLoadShipmentInfo(orderId: string): UseAsyncResult<ShipmentInfoModel> {
  const { apiService } = useService();
  return useAsync(() => apiService.getOrderShipment(orderId), [orderId]);
}
